import { action, createRequestTypes } from './index';

export const SHOW_PRELOADER = 'APP/SHOW_PRELOADER';
export const showPreloader = () => action(SHOW_PRELOADER);

export const HIDE_PRELOADER = 'APP/HIDE_PRELOADER';
export const hidePreloader = () => action(HIDE_PRELOADER);

export const HIDE_MENU = 'APP/HIDE_MENU';
export const hideMenu = () => action(HIDE_MENU);

export const SHOW_MENU = 'APP/SHOW_MENU';
export const showMenu = () => action(SHOW_MENU);

export const SET_NEW_BETS_FLAG = 'APP/SET_NEW_BETS_FLAG';
export const setNewBetsFlag = (value) => action(SET_NEW_BETS_FLAG, { value });



// WEBPACK FOOTER //
// ./app/actions/appActions.js